import { Paper } from '@mui/material'
import { GREY_BORDER } from 'utils/customizedTheme'

const PageBody = ({children}) => {
  return (
    <Paper className="transparent-background" sx={{ padding: '20px', boxShadow: 'none' }}>
      {children}
    </Paper>
  )
}

export default PageBody